import '../../css/mk-brand.css';
import {useEffect} from 'react';
import Koffeh from '../../media/partners/koffeh-logo.jpeg'
import LaBrushetta from '../../media/partners/la-brushchetta-logo.jpeg'
import LBL from '../../media/partners/lbl-logo.jpeg';
import PortoSushi from '../../media/partners/porto-sushi-logo.jpeg';
import Tuck from '../../media/partners/tuck-logo.jpeg';
import AlphaVerifi from '../../media/partners/alpha-verifi-logo.jpeg'

function Partners() {
  useEffect(() => {
  },);
  // @ts-ignore
  return (
    <div id="partners" className="m-2">
      <div className="container max-w-4xl">
        <div className="p-4">
          <div className="">
            <h1 className="flex justify-center text-2xl md:text-4xl lg:text-6xl font-extrabold mx-auto">Partners</h1>
          </div>
          <div className="container justify-center flex flex-wrap items-center">
            <a className="p-8" href="https://instagram.com/portosushi.argentario?igshid=YmMyMTA2M2Y=">
              <img className="mx-auto w-24 rounded-lg" alt="Porto Sushi link" src={PortoSushi} />
            </a>
            <a className="p-8" href="https://instagram.com/labruschettae?igshid=YmMyMTA2M2Y=">
              <img className="mx-auto w-24 rounded-lg" alt="Pasta fresca fatta link" src={LBL} />
            </a>
            <a className="p-8" href="https://www.tuckcoffee.com/en/">
              <img className="mx-auto w-24 rounded-lg" alt="Tuck Coffee link" src={Tuck} />
            </a>
            <a className="p-8" href="https://koffeh.com">
              <img className="mx-auto w-24 rounded-lg" alt="Koffeh Coffee link" src={Koffeh} />
            </a>
            <a className="p-8" href="https://instagram.com/labruschettae?igshid=YmMyMTA2M2Y=">
              <img className="mx-auto w-24 rounded-lg" alt="La bruschetta link" src={LaBrushetta} />
            </a>
            <a className="p-8" href="https://www.alpha-verifi.com/">
              <img className="mx-auto w-24 rounded-lg" alt="Alpha Verifi link" src={AlphaVerifi} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Partners;

